export default {"src":"/_next/static/media/like-52x49.6790a78e.svg","height":49,"width":52,"blurWidth":0,"blurHeight":0};